export const airlockHS = {
    header: "Rotary Airlocks",
    description: [
        "Superior quality 316 Stainless Steel housing cast in North America",
        "Round ANSI/DIN flanges that assist with cleaning & product flow",
        "No. 4 finish on rotor and internal product contact surfaces of housing optional",
        "Multiple drive configurations"

    ]
},
pressureBlower = {
    header: "Pressure Blower- PBH Series",
    description: [
        "The Pressure Blower Package utilizes positive air pressure to convey the material.",
        "The motive air/pressure is produced by a positive displacement blower which is located at the beginning of the conveying system.",
        "V-belt drive assembly and drive guard – drive guard features access via bolted removable doors, slotted front and drop through bottom",
        "Electric motor and adjustable mount base – 230/460 V, 3 Ph, 60 Hz; all major brands, enclosures and efficiency ratings available",
        "Combination chamber – absorption discharge silencer reduces noise radiation in the vicinity of the package",
        "Vibration isolation and expansion joint isolates blower from the silencer to prevent fatigue stresses to the silencer and piping"
    ]
},
sidewinder = {
    header: "Insertable Sidewinder- SWR Series",
    description: [
        "Features top loading filter media and offers easy media access, less downtime for maintenance and eliminates the need for confined space permitting. This is perhaps the most maintenance friendly filter available in the marketplace today. ",
        "Quick opening, top mounted, hinged door provides tool-less access to filter media ",
        "Adjustable pulse timer board with solenoids pre-mounted in an enclosure",
        "Sloped clean air plenum to allow for water runoff",
        "Reverse jet-pulse cleaning complete with a compressed air header and diaphragm valves",
        "Spun bond polyester with PTFE membrane, top removal, filter media that are self-supporting – 99.99% efficiency at ≥ 2 microns",
        "Magnehelic differential pressure gauge pre-mounted"
    ]
},
filterReceiver = {
    header: "Filter Reciever- HS Series",
    description: [
        "This smaller filter/receiver is the most sanitary option for line sizes up to 3 inches. Its tool-free access makes it easier to clean and maintain. It also offers flexible filter media options for different filter applications. Its individually pulsed filters make it a great solution for powders to pellets.",
        "Style 3 configuration designed for 17” HG vacuum service",
        "16 square feet of spun bonded polyester, top loading, spiral tube cartridge filter media",
        "Carbon steel compressed air header with aluminum diaphragm valves and push lock air fittings",
        "Compressed air piping, carbon steel, mounted in clean air plenum",
        "Carbon steel 60 degree hopper with flanged product discharge",
        "3” OD radial inlet with check valve"
    ]
},
ventFilterSFT = {
    header: "Vent Filter- SFT series",
    description: [
        "Clean air plenum with hinged access doors and clean air outlet stub",
        "Jet pulse cleaning complete with: Compressed air header and diaphragm valves, Internal air piping, Adjustable pulse timer board and solenoids mounted in a NEMA 4 enclosure, 16 oz. singed polyester filter media, Galvanized steel bag cups, Filter housing with mounting flange and hinged access door, Magnehelic differential pressure gauge with filter, 60 Degree hopper with radial inlet (Style 3 only), Support lugs (Style 3 only)" 
    ]
},
ventFilterSFTC = {
    header: "Vent Filter- SFTC series",
    description: [
        "This filter has a hinged top plenum which provides easy access to the top removal style filter cartridges. The filter media is a Spun Bonded Filter Cartridge with 45 pleats per element. No support cage is required.",
        "Jet pulse cleaning complete with: Compressed air header and diaphragm valves, Internal air piping, Adjustable pulse timer board and solenoids mounted in a NEMA 4 enclosure",
        "Spun bonded polyester cartridge media with 45 pleats per element",
        "Magnehelic differential pressure gauge with filter",
        "Flanged mounting connection"
    ]
},
productSeperator = {
    header: "Kleen Horizontal Product Seperator",
    description: [
        "Low profile (height) alternative to traditional cyclone collectors",
        "Designed to capture and separate large products (>1/4”) from a conveying air stream",
        "Access for inspection, cleaning and sanitizing is through a large tool-free door",
        "Silicone U-channel gasket door seal for heat and chemical compatibility",
        "Sanitary fitting for mounting high level probe/plug indication" 
    ]
},
sifter = {
    header: "Centrifugal Sifter",
    description: [
        "Stainless Steel Body with Ultra high throughput",
        "Easier screen change and tensioning",
        "No vibration, dust or noise",
        "SMore screen area than competitive size units",
        "Removable light-weight rotor assembly" 
    ]
},
hammermill = {
    header: "Hammer Mill",
    description: [
        "Durable, heavy-duty fabrication designed for superior operation and long lifespan",
        "A variety of hammer sizes, patterns, and screen openings available to tailor parameters for each application",
        "Rigid-frame screen mounting for uniform hammer-to-screen clearance",
        "Balanced HP to screen area for maximum power efficiency",
        "Symmetrical, precision balanced, and reversible rotors" 
    ]
},
megamill = {
    header: "Mega Mill",
    description: [
        "Heavy-duty fabrication designed for long life",
        "Unique cantilever rotor design coupled with large hinged doors for ease of maintenance and cleaning",
        "A dust-tight design ideal for use in a pneumatic-conveyor system",
        "Dynamically balanced rotor assembly and precision built bearing assembly designed for smooth performance and long life",
        "Maximum screen-to HP ratio ensures optimum capacity and uniform grinding" 
    ]
},
airclassmill = {
    header: "Air Classifying Mills",
    description: [
        "Durable welded carbon steel or stainless steel construction.",
        "Precision tolerances between rotor blade and grinding jaw or screen for uniform size reduction.",
        "Two-stage, closed circuit grinding for ultra-fine size reduction",
        "Interstage air classification for precise, on-line control and adjustment of particle size",
        "Large screen to horsepower ratio for greater capacity in each model."
    ]
},
finegrindmill = {
    header: "Fine Grinding Mills",
    description: [
        "Durable, welded carbon steel or stainless steel construction",
        "Simple, single-stage grinding for most dry, free-flowing materials",
        "Precision tolerances between rotor blade and grinding jaw or screen for uniform size-reduction",
        "Large screen-to-horsepower ratio ensures maximum capacity for each model",
        "Interchangeable screen & jaw combinations for more versatility"
    ]
},
airclass = {
    header: "Air Classifyers",
    description: [
        "Durable, heavy-duty fabrication in either carbon or stainless.",
        "State-of-the-art, precision manufactured, constant diameter rotors for the most efficient separation possible",
        "Precise control of the cut point by varying rotor speed",
        "Adjustable secondary air system for greater capture of near-size particles",
        "Low airflow resistance (pressure drop) designed for low-power usage"
    ]
},
beltfeeder = {
    header: "Weight Belt Feeders",
    description: [
        "± 1/4–1/2% Accuracy",
        "Open Construction with Sanitary Wash-Down Duty",
        "Cantilever Design for simplified belt removal",
        "304 Stainless Steel and UHMW Construction",
        "Pedestal Feeder Support"
    ]
},
beltscales = {
    header: "Belt Scales",
    description: [
        "Accurate weighing systems for applications from rocks to food to minerals",
        "Engineered to handle even the most difficult to feed dry materials",
        "Easy to use, dependable and accurate scales in single to four idler configurations",
        "Customizable, adjustable, and modular units to fit your process"
    ]
},
volumefeeder = {
    header: "Volumetric Feeders",
    description: [
        "Heavy duty stainless steel welded construction ",
        "Unique design minimizes hopper wear",
        "Stainless steel drive components available",
        "Industrial grade, food grade and chemical resistant",
        "Sealed roller bearings on paddle shafts "
    ]
},
lumflakebreaker = {
    header: "Lump/Flake Breakers",
    description: [
        "Durable, heavy-duty construction ensuring long service life",
        "Mild steel or stainless steel models available, depending upon the application",
        "Easy installation and maintenance and replacement of internal components",
        "A wide spectrum of blade designs, tailored for the specific product",
        "Externally mounted bearings with optional air-purge seals to mitigate contamination"
    ]
},
bulkbagfiller = {
    header: "Bulk Bag Fillers",
    description: [
        "Streamlined and Safe Bag Loading: The EasyLoad™ Rotary Bag Hanger provides reach-free bag loop attachment, ensuring operator safety with its shrouded design.",
        "Simplify Bag Removal Process: The Loop-Lok™ Powered Bag Strap Release offers secure bag loop support with automatic release, enhancing operator safety.",
        "Flexible and Ergonomic Bag Filling The PowerLift™ Hydraulic Fill Head Adjustment features a 48” travel range, allowing for ergonomic bag connections, adaptability to different bag sizes, and compensation for bag elongation.",
        "Get Consistent Filling Results: The Compact Logix PLC with 10” color HMI reduces labor costs, improves safety and operational efficiency, and delivers consistent, high-quality filling results."
    ]
},
bulkbagdischarge = {
    header: "Bulk Bag Dischargers",
    description: [
        "Heavy-Duty Bag Massagers ensure consistent material flow from difficult-to-discharge bags and reduces downtime from clogged or compacted materials",
        "Integrated dust collection system improves plant cleanliness, ensures operator safety and enhances process efficiency through reclaim of collected dust.",
        "High-quality hoists provide safe, reliable bag loading performance",
        "custom designed to deliver smooth, reliable performance for your unique application."
    ]
},
bulkbagconditioner = {
    header: "Bulk Bag Conditioners",
    description: [
        "The industry’s most compact footprint",
        "Heavy-duty 4” x 10” structural carbon steel tube main frame with gussets and continuous welds ",
        "User configurable parameters",
        "Custom designed to provide superior conditioningperformance for your application. "
    ]
},
containerdischarge = {
    header: "Container Discharging Systems",
    description: [
        "Designed specifically to fit your containers and promote smooth material flow.",
        "A wide variety of dust-tight, watertight, and hazardous location electrical and control system options available",
        "We utilize the finest components available; including: Parker, Bosch, SMC, Hoffman, Allen-Bradley, Turck, Baldor, and Reliance"
    ]
}


